// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__dlKpB","barLabel":"styles_barLabel__10tMp","barLabelPercentage":"styles_barLabelPercentage__3fVOk"};